import UserBookings from "./directive";
import UserBookingsFactory from "./factory";
import UserBooking from "./booking";
import UserBookingPeriod from "./booking-period";
import UserBookingPeriodEntry from "./booking-period-entry";
import AccordianArrow from "./accordian-arrow";
import UpdateBpNoteForm from "./update-bp-note-form";
import UserBookingList from "./booking-list";
import UserBookingDetails from "./booking-details";

import BpCancelationModalModule from "./booking-cancelation-modal/module";

const modul = angular
    .module("accountBookingComponentsModule", [BpCancelationModalModule])
    .factory("UserBookingsFactory", UserBookingsFactory)

    .directive("accordianArrow", AccordianArrow)
    .directive("updateBpNoteForm", UpdateBpNoteForm)
    .directive("userBookings", UserBookings)
    .directive("userBooking", UserBooking)
    .directive("userBookingPeriod", UserBookingPeriod)
    .directive("userBookingPeriodEntry", UserBookingPeriodEntry)
    .directive("userBookingList", UserBookingList)
    .directive("userBookingDetails", UserBookingDetails);

export default modul.name;
